import React from 'react';
import { Scissors, Phone, MapPin, Instagram } from 'lucide-react';
import { barbershopInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" dir="rtl">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 border-2 border-[#c9a962] flex items-center justify-center">
                <span className="text-[#c9a962] font-bold text-xl">NY</span>
              </div>
              <div>
                <p className="text-white font-bold">NY Barbershop</p>
                <p className="text-[#c9a962] text-xs tracking-wider">תספורות בהתאמה אישית</p>
              </div>
            </div>
            <p className="text-slate-400 text-sm">
              {barbershopInfo.owner} - מספרה יוקרתית ברעננה
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">קישורים מהירים</h4>
            <div className="space-y-2">
              <a
                href={barbershopInfo.bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-[#c9a962] transition-colors flex items-center gap-2"
              >
                <Scissors className="w-4 h-4" />
                הזמנת תור
              </a>
              <a
                href={barbershopInfo.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-[#c9a962] transition-colors flex items-center gap-2"
              >
                <Instagram className="w-4 h-4" />
                @{barbershopInfo.instagram}
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">צור קשר</h4>
            <div className="space-y-2">
              <a
                href={`tel:${barbershopInfo.phone}`}
                className="text-slate-400 hover:text-[#c9a962] transition-colors flex items-center gap-2"
              >
                <Phone className="w-4 h-4" />
                {barbershopInfo.phone}
              </a>
              <a
                href={barbershopInfo.googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-[#c9a962] transition-colors flex items-center gap-2"
              >
                <MapPin className="w-4 h-4" />
                {barbershopInfo.address}
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-slate-800 mb-8" />

        {/* Bottom */}
        <div className="flex items-center justify-center">
          <p className="text-slate-500 text-sm">
            © {currentYear} NY Barbershop. כל הזכויות שמורות.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
